import React, { useRef, useImperativeHandle } from "react";
import { Grid } from "@mui/material";
import { MASK_TYPE, TextField, SelectField, MenuItem } from "@curves/ui-base";
import { SourceTypeSelectField } from "@icoach/components/mutipleSelectField/";
import { refIsRequiredError, isEmpty } from "@util/utils";

const ProspectFormBox = React.forwardRef((props, ref) => {
	const { introducer: introducerProps = "", sourceType: sourceTypeProps = null, originTag: originTagProps = null, sourceOptions = [], requiredOptions = [] } = props;
	const nameRef = useRef(null);
	const phoneRef = useRef(null);
	const originRef = useRef(null);
	const neededRef = useRef(null);
	const referRef = useRef(null);
	const noteRef = useRef(null);

	useImperativeHandle(
		ref,
		() => ({
			isError: () => refIsRequiredError(nameRef, phoneRef, originRef, neededRef, referRef, noteRef),
			getResult: () => {
				let originData = originRef.current.getResult();
				return {
					...originData,
					name: nameRef.current.getResult(),
					cellPhone: phoneRef.current.getResult(),
					requiredType: neededRef.current.getResult(),
					introducer: referRef.current.getResult(),
					notes: noteRef.current.getResult(),
				};
			},
			getFullName: () => {
				const { isError: err, getResult: res } = nameRef.current;
				return err() ? "" : res();
			},

			getMulti: () => {
				const { isError: nameErr, getResult: nameRes } = nameRef.current;
				const { isError: oriErr, getResult: oriRes } = originRef.current;
				return nameErr() && oriErr() ? "" : { sourceType: oriRes(), name: nameRes() };
			},
		}),
		// eslint-disable-next-line
		[]
	);

	return (
		<Grid container spacing={3}>
			<Grid item xs={4}>
				<TextField label="姓名" ref={nameRef} required fullWidth />
			</Grid>
			<Grid item xs={4}>
				<TextField label="手機" ref={phoneRef} maskType={MASK_TYPE.MOB} required fullWidth />
			</Grid>
			<Grid item xs={4}>
				{!isEmpty(requiredOptions) && (
					<SelectField ref={neededRef} label="需求" name="needed" displayEmpty fullWidth>
						<MenuItem disabled value="">
							<em>請選擇</em>
						</MenuItem>
						{requiredOptions.map(({ text, value, disabled }) => (
							<MenuItem value={value} key={text} disabled={disabled}>
								{text}
							</MenuItem>
						))}
					</SelectField>
				)}
			</Grid>
			{!isEmpty(sourceOptions) && <SourceTypeSelectField ref={originRef} options={sourceOptions} defaultSourceType={sourceTypeProps} defaultSourceTag={originTagProps} gridSize={8} />}
			<Grid item xs={4}>
				<TextField defaultValue={introducerProps} label="介紹人" ref={referRef} fullWidth />
			</Grid>
			<Grid item xs={12}>
				<TextField label="備註" rows={2} ref={noteRef} fullWidth multiline />
			</Grid>
		</Grid>
	);
});

export default ProspectFormBox;
